import {Injectable, Injector} from "@angular/core";
import {ReportError} from "app/app.service";
import {ApiService} from "app/services/domain/api.service";
import {BaseListService, BatchResponse} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";
import {Transforms} from "app/shared/utils/transforms";
import {Lookup} from "framework/services/utils.service";

@Injectable()

export class ReportGenerateDownloadService extends BaseListService<Models.WellArchitectedFrameworkReportListRequest, Models.BatchRequest, Models.WellArchitectedFrameworkReport>
{
    constructor(inj: Injector,
                private m_api: ApiService)
    {
        super(inj, Models.WellArchitectedFrameworkReport);
    }

    @ReportError
    public list(listReq: Models.WellArchitectedFrameworkReportListRequest): Promise<Models.ListResponse>
    {
        return this.m_api.reportGenerateDownloadApi.reportList(listReq);
    }

    @ReportError
    protected async getBatchResponseImpl(req: Models.BatchRequest): Promise<BatchResponse<Models.WellArchitectedFrameworkReport>>
    {
        if (!req?.ids) return null;
        let batchResult: Lookup<Models.WellArchitectedFrameworkReport> = {};
        if (req.ids.length)
        {
            const request  = Models.RecordIdentityBatchRequest.newInstance({ids: Transforms.mapToRecordIdentities(req.ids)});
            const response = await this.m_api.reportGenerateDownloadApi.reportBatch(request);
            for (const report of response || []) batchResult[report.sys_id] = report;
        }
        return {results: batchResult};
    }

    protected createBatchRequest(listReq: Models.WellArchitectedFrameworkReportListRequest,
                                 ids: string[]): Models.BatchRequest
    {
        return Models.BatchRequest.newInstance({ids: ids});
    }

    public extractFilterValues(filter: Models.QueryOperator,
                               filterVal: string[],
                               pillars: Models.WellArchitectedFrameworkPillar[] = []): void
    {
        if (filter instanceof Models.QueryOperatorBinaryLogic)
        {
            this.extractFilterValues(filter.a, filterVal, pillars);
            this.extractFilterValues(filter.b, filterVal, pillars);
            return;
        }
        if (filter instanceof Models.AssessmentQueryPillar)
        {
            const ids = (filter as any).pillar_ids ?? (filter as any).value;
            if (Array.isArray(ids) && ids.length)
            {
                const matched    = pillars.filter(p => ids.includes(p.pillar_id));
                const pillarName = matched.length
                    ? matched.map(p => p?.pillar ?? p.pillar_id)
                             .join(", ")
                    : ids.join(", ");
                filterVal.push(`Pillar: ${pillarName}`);
            }
            return;
        }
        const entries = Object.entries(filter);
        for (const [key, value] of entries)
        {
            if (Array.isArray(value) && value.length)
            {
                const label = this.formatKey(key);
                filterVal.push(`${label}: ${value.join(", ")}`);
            }
        }
    }

    private formatKey(key: string): string
    {
        const customLabelMap: Record<string, string> = {
            natures               : "Best Practice Nature",
            best_practice_risks   : "Best Practice Severity",
            best_practice_statuses: "Best Practice Status",
            resource_types        : "Resource Type",
            resources             : "Resource",
            categories            : "Resource Category"
        };
        return customLabelMap[key] ?? "";
    }
}
